<app-report-shell
  [user]="user"
  [currentTime]="''"
  [sidebarCollapsed]="sidebarCollapsed"
  [mobileSidebarOpen]="mobileSidebarOpen"
  (menuToggle)="handleMenuToggle()"
  (closeMobileSidebar)="closeMobileSidebar()"
>
  <main class="log-sheet-page">
    <section class="log-sheet-page__panel app-card">
      <div class="log-sheet-page__panel-header">
        <div class="log-sheet-page__heading-copy">
          <h2 class="app-title-serif">Log Sheet Report</h2>
        </div>

        <button
          type="button"
          class="app-button app-button--primary log-sheet-filters__export"
          [disabled]="isLoading || isExporting"
          (click)="handleExportToExcel()"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M12 3v10"></path>
            <path d="m8 9 4 4 4-4"></path>
            <path d="M5 17v2h14v-2"></path>
          </svg>
          <span>{{ isExporting ? 'Exporting...' : 'Export to Excel' }}</span>
        </button>
      </div>

      <div class="log-sheet-page__panel-body">
        <div class="log-sheet-page__filters-row">
          <form class="log-sheet-filters" [formGroup]="filtersForm">
            <label class="app-form-field log-sheet-filters__field" [attr.for]="isBsDateMode ? 'log-sheet-bs-date-button' : 'log-sheet-ad-date-input'">
              <span class="app-form-label">Select Date</span>
              <div class="log-sheet-filters__input-shell log-sheet-filters__input-shell--bs" #bsDatePickerShell>
                @if (isBsDateMode) {
                  <button
                    type="button"
                    id="log-sheet-bs-date-button"
                    class="app-form-input log-sheet-filters__date-input log-sheet-filters__date-input--display"
                    aria-haspopup="dialog"
                    [attr.aria-expanded]="bsCalendarOpen"
                    (click)="openDatePicker()"
                  >
                    <span>{{ getFilterDateLabel() }}</span>
                    <span class="log-sheet-filters__date-icon" aria-hidden="true">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="3" y="5" width="18" height="16" rx="2"></rect>
                        <path d="M8 3v4"></path>
                        <path d="M16 3v4"></path>
                        <path d="M3 11h18"></path>
                      </svg>
                    </span>
                  </button>
                  @if (bsCalendarOpen) {
                    <dialog class="log-sheet-bs-calendar" open aria-label="Nepali calendar date picker" appClickOutside (appClickOutside)="closeBsDatePicker()">
                      <div class="log-sheet-bs-calendar__header">
                        <button type="button" class="log-sheet-bs-calendar__nav" aria-label="Previous month" (click)="shiftBsCalendarMonth(-1)">‹</button>
                        <div class="log-sheet-bs-calendar__title">
                          {{ bsCalendarMonth?.bs_month_name || 'Nepali Calendar' }} {{ bsCalendarMonth?.bs_year || '' }}
                        </div>
                        <button type="button" class="log-sheet-bs-calendar__nav" aria-label="Next month" (click)="shiftBsCalendarMonth(1)">›</button>
                      </div>
                      <div class="log-sheet-bs-calendar__weekdays">
                        @for (weekday of bsCalendarWeekdays; track weekday) {
                          <span>{{ weekday }}</span>
                        }
                      </div>
                      @if (bsCalendarLoading) {
                        <div class="log-sheet-bs-calendar__loading">Loading calendar...</div>
                      } @else {
                        <div class="log-sheet-bs-calendar__grid">
                          @for (cell of (bsCalendarMonth?.cells || []); track cell.bs_date) {
                            <button
                              type="button"
                              class="log-sheet-bs-calendar__day"
                              [class.log-sheet-bs-calendar__day--muted]="!cell.in_current_month"
                              [class.log-sheet-bs-calendar__day--selected]="cell.is_selected"
                              [class.log-sheet-bs-calendar__day--today]="cell.is_today"
                              (click)="selectBsCalendarCell(cell)"
                            >
                              {{ cell.bs_date_label }}
                            </button>
                          }
                        </div>
                      }
                    </dialog>
                  }
                  <input #hiddenDateInput id="log-sheet-bs-date-input" class="log-sheet-filters__hidden-date-input" type="date" formControlName="date" />
                } @else {
                  <input id="log-sheet-ad-date-input" class="app-form-input log-sheet-filters__date-input" type="date" formControlName="date" />
                }
              </div>
            </label>

            <label class="app-form-field log-sheet-filters__field" for="log-sheet-substation-autocomplete">
              <span class="app-form-label">Select Generator</span>
              <div class="log-sheet-filters__select-shell">
                <p-autocomplete
                  inputId="log-sheet-substation-autocomplete"
                  [(ngModel)]="substationSearchTerm"
                  [ngModelOptions]="{ standalone: true }"
                  [dropdown]="true"
                  size="compact"
                  [suggestions]="filteredSubstationOptions"
                  placeholder="Select Generator"
                  (completeMethod)="onSubstationSearchInput($event)"
                  (fieldBlur)="onSubstationSearchBlur()"
                ></p-autocomplete>
              </div>
            </label>

            <label class="app-form-field log-sheet-filters__field" for="log-sheet-time-interval-select">
              <span class="app-form-label">Time interval</span>
              <div class="log-sheet-filters__select-shell">
                <select
                  id="log-sheet-time-interval-select"
                  class="app-form-input log-sheet-filters__select"
                  formControlName="time_interval"
                  [disabled]="isLoading || isExporting"
                >
                  @for (option of timeIntervalOptions; track option.value) {
                    <option [ngValue]="option.value">{{ option.label }}</option>
                  }
                </select>
                <span class="log-sheet-filters__select-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
                    <path d="m6 9 6 6 6-6"></path>
                  </svg>
                </span>
              </div>
            </label>

            <div >
              <button
                type="button"
                class="app-button app-button--secondary equal app-filter-actions__button"
                [disabled]="isLoading || isExporting"
                (click)="clearFilters()"
              >
                Clear
              </button>
            </div>
          </form>

          <div class="log-sheet-page__detail-row" aria-label="Log sheet summary modes">
            <div class="log-sheet-page__detail-buttons" role="tablist">
              <button
                type="button"
                class="log-sheet-page__detail-button"
                [class.log-sheet-page__detail-button--active]="isDetailModeActive('generation')"
                (click)="handleDetailModeChange('generation')"
              >
                <span class="log-sheet-page__detail-button-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 3v18"></path>
                    <path d="M8 7h8"></path>
                    <path d="M8 12h8"></path>
                    <path d="M8 17h8"></path>
                  </svg>
                </span>
                <span>Power(MW)</span>
              </button>
               <button
                type="button"
                class="log-sheet-page__detail-button"
                [class.log-sheet-page__detail-button--active]="isDetailModeActive('interruption')"
                (click)="handleDetailModeChange('interruption')"
              >
                <span class="log-sheet-page__detail-button-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 2 3 17h7l-1 5 12-15h-7l-2-5Z"></path>
                  </svg>
                </span>
                <span>Interruption/Crossborder/Load(MW)</span>
              </button>

              <button
                type="button"
                class="log-sheet-page__detail-button"
                [class.log-sheet-page__detail-button--active]="isDetailModeActive('frequency-voltage')"
                (click)="handleDetailModeChange('frequency-voltage')"
              >
                <span class="log-sheet-page__detail-button-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M4 12h4l2-7 4 14 2-7h4"></path>
                  </svg>
                </span>
                <span>Frequency & Voltage Profile</span>
              </button>



             

              <button
                type="button"
                class="log-sheet-page__detail-button"
                [class.log-sheet-page__detail-button--active]="isDetailModeActive('water-level')"
                (click)="handleDetailModeChange('water-level')"
              >
                <span class="log-sheet-page__detail-button-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 3s4 4.5 4 8.5A4 4 0 1 1 8 11.5C8 7.5 12 3 12 3Z"></path>
                    <path d="M9.5 16.5h5"></path>
                  </svg>
                </span>
                <span>Water Level(m)</span>
              </button>

              <button
                type="button"
                class="log-sheet-page__detail-button"
                [class.log-sheet-page__detail-button--active]="isDetailModeActive('summary')"
                (click)="handleDetailModeChange('summary')"
              >
                <span class="log-sheet-page__detail-button-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M6 3h9l3 3v15H6z"></path>
                    <path d="M9 12h6"></path>
                    <path d="M9 16h6"></path>
                  </svg>
                </span>
                <span>Summary</span>
              </button>
            </div>

          </div>
        </div>

        <div #tableWrap class="log-sheet-page__table-wrap app-table-scroll">
          <table class="log-sheet-table">
            <thead>
              <tr>
                <th scope="col" class="log-sheet-table__sticky-column log-sheet-table__header--title-case" rowspan="2">
                  @if (isSummaryMode()) {
                    <span class="log-sheet-table__base-load">Base Load={{ getBaseLoadText() }}</span>
                  }
                  <span>{{ getFirstColumnHeaderLabel() }}</span>
                </th>
                @for (group of getVisibleBlockGroups(); track trackByBlockGroup($index, group)) {
                  <th
                    scope="colgroup"
                    [attr.colspan]="group.span"
                    [class]="'log-sheet-table__band log-sheet-table__band--' + group.period"
                  >
                    {{ group.label }}
                  </th>
                }
                @if (isSummaryMode()) {
                  <th
                    scope="col"
                    class="log-sheet-table__summary-cell log-sheet-table__summary-cell--scheduled log-sheet-table__header--title-case"
                    rowspan="2"
                    tooltip="Installed Capacity"
                    title="Installed Capacity"
                  >
                    IC ({{ getReportUnitLabel() }})
                  </th>
                  <th scope="col" class="log-sheet-table__summary-cell log-sheet-table__summary-cell--actual log-sheet-table__header--title-case" rowspan="2">Max({{ getReportUnitLabel() }})</th>
                  <th scope="col" class="log-sheet-table__summary-cell log-sheet-table__summary-cell--deviation log-sheet-table__header--title-case" rowspan="2">Min({{ getReportUnitLabel() }})</th>
                  <th scope="col" class="log-sheet-table__summary-cell log-sheet-table__summary-cell--energy log-sheet-table__header--title-case" rowspan="2">Energy(MWh)</th>
                }
              </tr>
              <tr>
                @for (block of getVisibleBlockColumns(); track trackByBlock($index, block)) {
                  <th
                    scope="col"
                    [class]="'log-sheet-table__hour-cell log-sheet-table__hour-cell--' + block.period"
                    [ngClass]="getBlockTimeHighlightClass(block)"
                  >
                    {{ block.label }}
                  </th>
                }
              </tr>
            </thead>
            <tbody>
              @if (isLoading) {
                <tr>
                  <td [attr.colspan]="getEmptyColspan()" class="log-sheet-page__empty-state">Loading log sheet data...</td>
                </tr>
              } @else if (getTableRows().length) {
                @if (detailMode === 'interruption' || detailMode === 'frequency-voltage') {
                  @for (row of getTableRows(); track trackByRow($index, row)) {
                    <tr [class]="'log-sheet-table__hierarchy-row log-sheet-table__hierarchy-row--' + row.row_kind">
                      <td class="log-sheet-table__sticky-column">
                        <div
                          [class]="'log-sheet-table__station' + (row.row_kind === 'data' ? '' : ' log-sheet-table__station--total') + ' log-sheet-table__station--level-' + (row.row_level ?? 0)"
                        >
                          @if (hasHierarchyChildren(row)) {
                            <button
                              type="button"
                              class="log-sheet-table__hierarchy-toggle"
                              [attr.aria-label]="(isHierarchyExpanded(row) ? 'Collapse' : 'Expand') + ' ' + row.station_name"
                              (click)="toggleHierarchyRow(row); $event.stopPropagation()"
                            >
                              <span aria-hidden="true">{{ isHierarchyExpanded(row) ? '-' : '+' }}</span>
                            </button>
                          } @else if (row.parent_row_key) {
                            <span class="log-sheet-table__hierarchy-toggle log-sheet-table__hierarchy-toggle--placeholder" aria-hidden="true"></span>
                          }
                          @if (row.row_kind === 'interruption-line' || row.row_kind === 'interruption-substation') {
                            <span>{{ row.station_name }}</span>
                          } @else {
                            <strong>{{ row.station_name }}</strong>
                          }
                        </div>
                      </td>
                      @for (cell of getVisibleRowBlocks(row); track cell.block_no) {
                        <td
	                          [class]="'log-sheet-table__hour-cell log-sheet-table__hour-cell--' + cell.period"
	                          [ngClass]="getBlockTimeHighlightClass(cell)"
	                          [class.log-sheet-table__hour-cell--edited]="isEditedCell(cell)"
	                          [class.log-sheet-table__hour-cell--edited-admin]="isAdminEditedCell(cell)"
	                          [class.log-sheet-table__hour-cell--edited-user]="isUserEditedCell(cell)"
	                          (dblclick)="beginCellEdit(row, cell)"
                        >
                          <ng-container
                            [ngTemplateOutlet]="logSheetReadOnlyCellTemplate"
                            [ngTemplateOutletContext]="{ $implicit: cell, row: row, showEmptyState: false }"
                          ></ng-container>
                        </td>
                      }
                      @if (isSummaryMode()) {
                        <td class="log-sheet-table__summary-cell log-sheet-table__summary-cell--scheduled">{{ getInstalledCapacityText(row) }}</td>
                        <td class="log-sheet-table__summary-cell log-sheet-table__summary-cell--actual">{{ getRowMaxText(row) }}</td>
                        <td class="log-sheet-table__summary-cell log-sheet-table__summary-cell--deviation">{{ getRowMinText(row) }}</td>
                        <td
                          class="log-sheet-table__summary-cell log-sheet-table__summary-cell--energy"
                          [class.log-sheet-table__hour-cell--edited]="isEnergyCellEdited(row)"
                          [class.log-sheet-table__hour-cell--edited-admin]="isEnergyEditedByAdmin(row)"
                          [class.log-sheet-table__hour-cell--edited-user]="isEnergyEditedByUser(row)"
                          (dblclick)="beginEnergyEdit(row)"
                        >{{ getRowEnergyText(row) }}</td>
                      }
                    </tr>
                  }
                } @else {
                  @for (row of getTableRows(); track trackByRow($index, row)) {
                    @if (isHierarchyTotalRow(row)) {
                      <tr [class]="'log-sheet-table__hierarchy-row log-sheet-table__hierarchy-row--' + (row.row_kind === 'power-total-thermal' ? 'source-total' : row.row_kind) + (selectedViewTab === 'summary' && row.row_kind === 'power-frequency-voltage-profile' ? ' log-sheet-table__hierarchy-row--power-water-level' : '')">
                        <td class="log-sheet-table__sticky-column">
                          <div [class]="'log-sheet-table__station log-sheet-table__station--total log-sheet-table__station--level-' + (row.row_level ?? 0)">
                            @if (hasHierarchyChildren(row)) {
                              <button
                                type="button"
                                class="log-sheet-table__hierarchy-toggle"
                                [attr.aria-label]="(isHierarchyExpanded(row) ? 'Collapse' : 'Expand') + ' ' + row.station_name"
                                (click)="toggleHierarchyRow(row); $event.stopPropagation()"
                              >
                                <span aria-hidden="true">{{ isHierarchyExpanded(row) ? '-' : '+' }}</span>
                              </button>
                            } @else {
                              <span class="log-sheet-table__hierarchy-toggle log-sheet-table__hierarchy-toggle--placeholder" aria-hidden="true"></span>
                            }
                            @if (
                              row.row_kind === 'interruption-line' ||
                              row.row_kind === 'interruption-substation' ||
                              row.row_kind === 'power-thermal-generator' ||
                              row.row_kind === 'power-water-level-generator' ||
                              row.row_kind === 'power-spill-generator' ||
                              row.row_kind === 'power-kabeli-corridor-generator' ||
                              row.row_kind === 'power-small-generator'
                            ) {
                              <span>{{ row.station_name }}</span>
                            } @else {
                              <strong>{{ row.station_name }}</strong>
                            }
                          </div>
                        </td>
                        @for (cell of getVisibleRowBlocks(row); track cell.block_no) {
                          <td
	                            [class]="'log-sheet-table__hour-cell log-sheet-table__hour-cell--' + cell.period"
	                            [ngClass]="getBlockTimeHighlightClass(cell)"
	                            [class.log-sheet-table__hour-cell--edited]="isEditedCell(cell)"
	                            [class.log-sheet-table__hour-cell--edited-admin]="isAdminEditedCell(cell)"
	                            [class.log-sheet-table__hour-cell--edited-user]="isUserEditedCell(cell)"
	                            (dblclick)="beginCellEdit(row, cell)"
                          >
                            <ng-container
                              [ngTemplateOutlet]="logSheetReadOnlyCellTemplate"
                              [ngTemplateOutletContext]="{ $implicit: cell, row: row, showEmptyState: false }"
                            ></ng-container>
                          </td>
                        }
                        @if (isSummaryMode()) {
                          <td class="log-sheet-table__summary-cell log-sheet-table__summary-cell--scheduled">{{ getInstalledCapacityText(row) }}</td>
                          <td class="log-sheet-table__summary-cell log-sheet-table__summary-cell--actual">{{ getRowMaxText(row) }}</td>
                          <td class="log-sheet-table__summary-cell log-sheet-table__summary-cell--deviation">{{ getRowMinText(row) }}</td>
                          <td
                            class="log-sheet-table__summary-cell log-sheet-table__summary-cell--energy"
                            [class.log-sheet-table__hour-cell--edited]="isEnergyCellEdited(row)"
                            [class.log-sheet-table__hour-cell--edited-admin]="isEnergyEditedByAdmin(row)"
                            [class.log-sheet-table__hour-cell--edited-user]="isEnergyEditedByUser(row)"
                            (dblclick)="beginEnergyEdit(row)"
                          >{{ getRowEnergyText(row) }}</td>
                        }
                      </tr>
                    } @else {
                      <tr
                        class="log-sheet-table__hierarchy-row log-sheet-table__hierarchy-row--data"
                        [class.log-sheet-table__hierarchy-row--power-small-generator]="isHydroSmallPowerRow(row) || row.row_kind === 'power-small'"
                      >
                        <td class="log-sheet-table__sticky-column">
                          <div
                            [class]="'log-sheet-table__station log-sheet-table__station--level-' + (row.row_level ?? 3)"
                            [class.log-sheet-table__station--kathmandu-load-generator]="row.row_kind === 'power-kathmandu-load-generator'"
                          >
                            <strong>{{ row.station_name }}</strong>
                             
                          </div>
                        </td>
                        @for (cell of getVisibleRowBlocks(row); track cell.block_no) {
                          <td
	                            [class]="'log-sheet-table__hour-cell log-sheet-table__hour-cell--' + cell.period"
	                            [ngClass]="getBlockTimeHighlightClass(cell)"
	                            [class.log-sheet-table__hour-cell--edited]="isEditedCell(cell)"
	                            [class.log-sheet-table__hour-cell--edited-admin]="isAdminEditedCell(cell)"
	                            [class.log-sheet-table__hour-cell--edited-user]="isUserEditedCell(cell)"
	                            (dblclick)="beginCellEdit(row, cell)"
                          >
                            <ng-container
                              [ngTemplateOutlet]="logSheetReadOnlyCellTemplate"
                              [ngTemplateOutletContext]="{ $implicit: cell, row: row, showEmptyState: true }"
                            ></ng-container>
                          </td>
                        }
                        @if (isSummaryMode()) {
                          <td class="log-sheet-table__summary-cell log-sheet-table__summary-cell--scheduled">{{ getInstalledCapacityText(row) }}</td>
                          <td class="log-sheet-table__summary-cell log-sheet-table__summary-cell--actual">{{ getRowMaxText(row) }}</td>
                          <td class="log-sheet-table__summary-cell log-sheet-table__summary-cell--deviation">{{ getRowMinText(row) }}</td>
                          <td
                            class="log-sheet-table__summary-cell log-sheet-table__summary-cell--energy"
                            [class.log-sheet-table__hour-cell--edited]="isEnergyCellEdited(row)"
                            [class.log-sheet-table__hour-cell--edited-admin]="isEnergyEditedByAdmin(row)"
                            [class.log-sheet-table__hour-cell--edited-user]="isEnergyEditedByUser(row)"
                            (dblclick)="beginEnergyEdit(row)"
                          >{{ getRowEnergyText(row) }}</td>
                        }
                      </tr>
                    }
                  }
                }
              } @else {
                <tr>
                  <td [attr.colspan]="getEmptyColspan()" class="log-sheet-page__empty-state"><span class="log-sheet-page__empty-text">No generation data found for the selected filters</span></td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        <div class="log-sheet-page__legend" aria-label="Hourly bands legend">
	          <span class="log-sheet-page__legend-item">
	            <span class="log-sheet-page__legend-swatch log-sheet-page__legend-swatch--current-block" aria-hidden="true"></span>
	            <span>Current Time Block</span>
	          </span>
	          <span class="log-sheet-page__legend-item">
	            <span class="log-sheet-page__legend-swatch log-sheet-page__legend-swatch--previous-block" aria-hidden="true"></span>
	            <span>Last Synced Time Block</span>
	          </span>
	          <span class="log-sheet-page__legend-item">
	            <span class="log-sheet-page__legend-swatch log-sheet-page__legend-swatch--admin-edited-cell" aria-hidden="true"></span>
	            <span>Admin Edited Cell</span>
	          </span>
	          <span class="log-sheet-page__legend-item">
	            <span class="log-sheet-page__legend-swatch log-sheet-page__legend-swatch--user-edited-cell" aria-hidden="true"></span>
	            <span>Generator/Substation Edited Cell</span>
	          </span>
	          <span class="log-sheet-page__legend-item">
	            <span class="log-sheet-page__legend-swatch log-sheet-page__legend-swatch--small-generator" aria-hidden="true"></span>
	            <span>Other small generators</span>
          </span>
        </div>
      </div>
    </section>
    <ng-template #logSheetReadOnlyCellTemplate let-cell let-row="row" let-showEmptyState="showEmptyState">
      <div class="log-sheet-table__cell-content">
        <span
          class="log-sheet-table__cell-text"
          [class.log-sheet-table__cell-text--empty]="showEmptyState && (cell.value === null || cell.value === undefined)"
        >
          {{ row ? getRowCellText(row, cell) : getCellText(cell) }}
        </span>
        @if (cell.remarks) {
          <ng-container [ngTemplateOutlet]="logSheetRemarkIndicatorTemplate" [ngTemplateOutletContext]="{ $implicit: cell }"></ng-container>
        }
      </div>
    </ng-template>

    <ng-template #logSheetRemarkIndicatorTemplate let-cell>
      <button
        type="button"
        class="log-sheet-table__remark-indicator"
        [attr.aria-label]="'Saved remarks for block ' + cell.label"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="9"></circle>
          <path d="M12 8h.01"></path>
          <path d="M11 11h1v5h1"></path>
        </svg>
        <span class="log-sheet-table__remark-tooltip" role="tooltip">{{ cell.remarks }}</span>
      </button>
    </ng-template>
  </main>

  @if (editDataModalOpen) {
    <div class="app-modal-backdrop">
      <dialog class="app-modal log-sheet-edit-modal" open>
        <div class="log-sheet-edit-modal__header">
          <div>
            <h3 class="app-title-serif">Edit Data</h3>
            <p>Update the selected cell value or copy the previous block value before saving.</p>
          </div>

          <button
            type="button"
            class="app-button app-button--icon log-sheet-edit-modal__close"
            aria-label="Close edit data modal"
            (click)="closeEditDataModal()"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round">
              <path d="M6 6 18 18"></path>
              <path d="M18 6 6 18"></path>
            </svg>
          </button>
        </div>

        <form [formGroup]="remarksForm" (ngSubmit)="saveEditData()">
          <div class="log-sheet-edit-modal__body">
            <label class="app-form-field">
              <span class="app-form-label">Data Value</span>
              <input
                class="app-form-input"
                type="number"
                step="1"
                inputmode="numeric"
                placeholder="Enter data value"
                formControlName="data_value"
                (input)="onEditDataValueInput($event)"
              />
            </label>

            @if (!isEnergyEditContext()) {
              <div class="log-sheet-edit-modal__radio-row  radio_inline" role="radiogroup" aria-label="Previous value source">
                <label class="log-sheet-edit-modal__radio-option">
                  <input
                    type="radio"
                    name="previous-value-source"
                    [checked]="remarksForm.get('copy_previous_block_value')?.value"
                    [disabled]="arePreviousValueControlsDisabled()"
                    (change)="onPreviousValueModeChange('copy')"
                  />
                  <span>Copy Previous Block Value</span>
                </label>

                <label class="log-sheet-edit-modal__radio-option">
                  <input
                    type="radio"
                    name="previous-value-source"
                    [checked]="remarksForm.get('carry_over_previous_day_values')?.value"
                    [disabled]="arePreviousValueControlsDisabled()"
                    (change)="onPreviousValueModeChange('carry')"
                  />
                  <span>Carry Over Previous Day Values</span>
                </label>
              </div>
            }

            <label class="app-form-field">
              <span class="app-form-label">Remarks</span>
              <textarea
                class="app-form-input app-form-textarea log-sheet-edit-modal__textarea"
                rows="5"
                placeholder="Optional remarks"
                formControlName="remarks"
              ></textarea>
            </label>
          </div>

          <div class="log-sheet-edit-modal__footer">
            <button type="button" class="app-button app-button--secondary" (click)="closeEditDataModal()">Cancel</button>
            <button type="submit" class="app-button app-button--primary">Save</button>
          </div>
        </form>
      </dialog>
    </div>
  }
</app-report-shell>
